// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './styles/index.scss'
import {createRouter} from './router'
import {createStore} from './store'
import ElementUI from 'element-ui'
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import * as api from './api' // 接口
import BaiduMap from 'vue-baidu-map'

const router = createRouter(Vue)
Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: 'CAGHfKQRXPTl8MsVZlv9uGTefa1FlCZZ'
})
Vue.prototype.$axios = axios
Vue.prototype.$http = axios
const store = createStore(Vue)
Vue.config.productionTip = false

window.myVue = new Vue({
  el: '#app',
  router,
  store,
  api,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js